import * as React from 'react';

import FlagOutlinedIcon from '@mui/icons-material/FlagOutlined';
import { Button, Divider } from '@mui/material';

import { AuthContext } from '@kamernet/core/Auth/AuthContext';
import { useIntl } from '@kamernet/core/Intl';
import { CommonStyles } from '@kamernet/styles/CommonStyles';

import { SignupCard } from '@kamernet/modules/Listing/components/SignupCard';

import { ListingDetailsContext } from '../../ListingDetailsContext';
import { ContactCard } from '../ContactLandlord/components/ContactCard/ContactCard';
import { LandlordPreviewMode } from '../ContactLandlord/components/LandlordPreviewMode/LandlordPreviewMode';
import { LandlordProfile } from '../ContactLandlord/components/LandlordProfile';
import { PropertyDetails } from '../PropertyDetails';
import { ReportListing } from '../ReportListing/ReportListing';

import styles from './Overview.module.css';

export const Overview = () => {
  const { isAuthenticated, userProfile } = AuthContext.useContext();
  const { listingDetails } = ListingDetailsContext.useContext();
  const { T } = useIntl();

  const [openReportListingModal, setOpenReportListingModal] =
    React.useState<boolean>(false);

  return (
    <section>
      <div className={styles.root}>
        <PropertyDetails />
        <Divider />
        {listingDetails.isPreviewMode ? (
          <LandlordPreviewMode />
        ) : (
          <React.Fragment>
            <LandlordProfile />
            <ContactCard />
          </React.Fragment>
        )}
      </div>

      {!isAuthenticated && (
        <div className={CommonStyles.margin_top_1}>
          <SignupCard
            hideImage
            title={T('search_alerts.ldp.heading.similar_places')}
            subtitle={T('search_alerts.ldp.body.like_this_place')}
            buttonMessage={T('search_alerts.ldp.cta.sign_up')}
          />
        </div>
      )}

      {isAuthenticated && userProfile?.haspremiumaccount && (
        <div className={styles.report}>
          <Button
            className={styles.faintText}
            startIcon={<FlagOutlinedIcon className={styles.faintText} />}
            onClick={() => setOpenReportListingModal(true)}
          >
            {T('lbl.report_advert')}
          </Button>
        </div>
      )}
      <ReportListing
        open={openReportListingModal}
        setOpen={setOpenReportListingModal}
      />
    </section>
  );
};
